export default {
    betslip: {
        draftCreated: 'Udkastet blev tilføjet',
        couponAdded: 'Kupon tilføjet',
    },
    editGroup: {
        updated: 'Gruppeoplysninger er blevet opdateret',
    },
    coupon: {
        couponUpdated: 'Ændringer er blevet gemt',
        couponUpdateFail: 'Kunne ikke gemme kuponændringer',
    },
    validation: {
        clubNameOnlySpaces: 'Klubnavn må ikke kun indeholde mellemrum',
        onlyNumbers: 'Må kun indeholde tal',
        poolAmountExceed: 'Pool amount > 60.000 Kr.',
        required: 'Skal udfyldes',
    },
};
